import * as AlertBarState from '../../components/alert-bar/AlertBar.state';
import { LOGOUT } from '../../state/reducer';
import * as Nested from '../../utils/Nested';
import { LoginFormBody } from './Login';

export const SUBMIT_LOGIN_FORM = 'login/SUBMIT_LOGIN_FORM';
export const submitLoginForm = () => ({ type: SUBMIT_LOGIN_FORM });

export const LOGIN_SUCCESS = 'login/LOGIN_SUCCESS';
export const loginSuccess = (payload) => ({
  type: LOGIN_SUCCESS,
  payload,
});

const SET_IS_LOGGING_OUT = 'login/SET_IS_LOGGING_OUT';
export const setIsLoggingOut = (payload) => ({
  type: SET_IS_LOGGING_OUT,
  payload,
});

const LOGIN_ERROR = 'login/LOGIN_ERROR';
export const loginError = (error) => ({
  type: LOGIN_ERROR,
  payload: { error },
});

const initialState = {
  isLoggingOut: false,
  submitting: false,
  error: false,
  cashier: {
    first_name: '',
    last_name: '',
    email: '',
  },
};

const loadInitialState = () => {
  try {
    const sessionState = localStorage.getItem('session');
    if (!sessionState) return initialState;
    else return JSON.parse(localStorage.getItem('session'));
  } catch (err) {
    return initialState;
  }
};

export const _reducer = (state = loadInitialState(), { type, payload }) => {
  switch (type) {
    case LOGOUT:
      return {
        ...state,
        isLoggingOut: true,
      };
    case SET_IS_LOGGING_OUT:
      return {
        ...state,
        isLoggingOut: payload,
      };
    case SUBMIT_LOGIN_FORM:
      return { ...state, submitting: true };
    case LOGIN_SUCCESS:
      return {
        ...state,
        submitting: false,
        error: false,
        cashier: payload.cashier,
      };
    case LOGIN_ERROR:
      return {
        ...state,
        submitting: false,
        error: payload,
      };
    default:
      return state;
  }
};

export const _mapStateToProps = (state) => ({
  ...state.login,
});
export const _mapDispatchToProps = (dispatch) => ({
  submitLoginForm: () => dispatch(submitLoginForm()),
});

export const ALERT_BAR_ACTION = 'login/ALERT_BAR_ACTION';
export const loginAlertBarAction = Nested.nestedAction(ALERT_BAR_ACTION);

export const LOGIN_FORM_ACTION = 'login/LOGIN_FORM_ACTION';
export const loginFormAction = Nested.nestedAction(LOGIN_FORM_ACTION);

// What does this state tree actually look like here? so hard to tell

const {
  reducer: nestedReducer,
  mapStateToProps,
  mapDispatchToProps,
  actions,
} = Nested.nestStates(
  {
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps,
  },
  {
    forms: {
      loginForm: {
        ...LoginFormBody,
        actionType: LOGIN_FORM_ACTION,
      },
    },
    alertBars: {
      loginAlertBar: {
        ...AlertBarState,
        actionType: ALERT_BAR_ACTION,
      },
    },
  },
  'login',
);

const reducer = (state, action) => nestedReducer(state, action);

export { reducer, mapStateToProps, mapDispatchToProps, actions };
